/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeaderKpiViewModel } from '../../models/header-kpi-view-model';

export interface GetHeaderKpi$Params {
  workCenterId: number;
}

export function getHeaderKpi(http: HttpClient, rootUrl: string, params: GetHeaderKpi$Params, context?: HttpContext): Observable<StrictHttpResponse<HeaderKpiViewModel>> {
  const rb = new RequestBuilder(rootUrl, getHeaderKpi.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeaderKpiViewModel>;
    })
  );
}

getHeaderKpi.PATH = '/api/v1/ProductionOrder/GetHeaderKpi/{workCenterId}';
